// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'user-check-solid';

export const Component = () => (
  <path d='M23.46 3.628a.434.434 0 0 1 .145.335c0 .144-.048.24-.144.335l-4.933 4.933a.542.542 0 0 1-.383.144c-.096 0-.191-.048-.287-.144l-2.97-2.442a.542.542 0 0 1-.143-.383c0-.335.143-.479.478-.479.144 0 .24.048.288.096l2.634 2.204 4.598-4.598c.048-.096.191-.144.383-.144.144 0 .239.048.335.144ZM3.97 6.885c0-1.34.479-2.49 1.436-3.448C6.363 2.479 7.512 2 8.854 2c1.389 0 2.538.479 3.496 1.437.958.958 1.437 2.107 1.437 3.448 0 1.39-.48 2.538-1.437 3.496-.958.958-2.107 1.437-3.496 1.437-1.34 0-2.49-.479-3.449-1.437-.957-.958-1.436-2.107-1.436-3.496Zm4.885 5.89c2.155 0 4.023.767 5.555 2.3 1.533 1.533 2.3 3.4 2.3 5.555v.48c0 .335-.144.526-.48.526H1.528c-.336 0-.527-.191-.527-.527v-.479c0-2.155.766-3.975 2.3-5.507 1.58-1.58 3.4-2.347 5.555-2.347h-.001Z' />
);

export const viewBox = '0 0 25 25';
